import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { INNER_BOTTOM_SPACE_DESK, colorsPalette } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: 36,
        paddingBottom: 36,
        background: theme.palette.secondary.dark,
        [theme.breakpoints.up('md')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
        overflowX: 'hidden',
      },
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: colorsPalette.white,
      },
      contentWrapper: {
        background: theme.palette.secondary.light,
        boxShadow: `0px 3px 6px ${colorsPalette.black}`,
        borderRadius: '5px',
        overflow: 'hidden',
        padding: '41px 26px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
          boxShadow: 'none',
          background: 'none',
          padding: 0,
        },
      },
      content: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 28,
        [theme.breakpoints.up('md')]: {
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      heading: {
        marginBottom: 22,
        [theme.breakpoints.up('md')]: {
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      item: {
        display: 'flex',
        marginBottom: 30,
        '&:last-child': {
          marginBottom: 0,
        },

        [theme.breakpoints.up('md')]: {
          marginBottom: 44,
        },
      },
      textWrapper: {
        marginLeft: 23,
        [theme.breakpoints.up('md')]: {
          marginLeft: 32,
          width: 300,
        },
      },
      imageMacWrap: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
          display: 'block',
          marginLeft: 88,
          width: 364,
          height: 364,
          '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: 5,
          },
        },
        [theme.breakpoints.up('lg')]: {
          width: 564,
        },
        [theme.breakpoints.up('xl')]: {
          width: 634,
        },
      },
      imageWrap: {
        width: '48px',
        flexShrink: 0,
        [theme.breakpoints.up('md')]: {
          width: 65,
        },
        '& img': {
          width: '100%',
        },
      },
      itemTitle: {
        [theme.breakpoints.up('md')]: {
          marginBottom: 12,
        },
      },
      itemText: {
        fontSize: 16,
        lineHeight: '20px',
        [theme.breakpoints.up('md')]: {
          fontSize: 18,
          lineHeight: 1.5,
        },
      },
      btn: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          width: 'auto',
        },
      },
    }),
  );
export default useStyles;
